import React from "react";
import { useLocation, useParams } from "react-router-dom";
import OnboardStudentForm from "../components/OnboardStudentForm";

export default function StudentOnboarding() {
  const location = useLocation();
  const { uid = "" } = useParams();
  const initialStudentRecord = location.state?.studentRecord || null;

  return (
    <OnboardStudentForm
      initialUid={uid}
      initialStudentRecord={initialStudentRecord}
    />
  );
}
